import React from 'react'

const SizerContext = React.createContext({
  scrollIntoView: () => {},
})

export default SizerContext
